import React from 'react'
import { Form } from 'formsy-semantic-ui-react';
import { Button, Modal, Grid } from 'semantic-ui-react';
import { multiLineText } from '../../../../common/RegexValidation';
import TextEditor from '../../../../common/TextEditor'
class PracticeRejectionNotesModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            note: ''
        }
    }

    componentWillMount() {
    }
    handleClose = () => {
        this.props.closeModal();
    }
    addNote() {
        this.props.addNote(this.state.note);
        this.props.reject()
    }

    updateText = (data, name) => {
        if (name === "Reason for Rejection") {
            this.setState({ note: data })
        }
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <Modal
                style={inlineStyle.modal}
                open={this.props.openModal}
                onClose={this.handleClose}
                size='small'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header style={{ color: '#3fa9f5' }}>{this.props.playBookName}
                </Modal.Header>
                <Form
                    name="rejectionNotesForm"
                    id="rejectionNotesForm"
                // onValidSubmit={(data) => { this.addNote(data) }}
                >

                    <Modal.Content>

                        <Grid columns={3} >
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    {/* <Form.TextArea
                                        name="note"
                                        label="Reason for Rejection"
                                        required
                                        id="note"
                                        validations={{ matchRegexp: multiLineText }}
                                        required
                                        validationErrors={{
                                            matchRegexp: 'No numbers or special characters allowed. No space allowed in starting.',
                                            isDefaultRequiredValue: 'Reason for rejection is required',
                                        }}
                                        errorLabel={errorLabel}
                                        instantValidation
                                    /> */}
                                    <TextEditor
                                        name="Reason for Rejection"
                                        text={this.state.note}
                                        type="textarea"
                                        onChangeText={this.updateText}
                                    />
                                </Grid.Column>

                            </Grid.Row>
                        </Grid>
                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button
                            id='cancelBtn'
                            type="button"
                            className="button-cancel"
                            onClick={this.handleClose}> Cancel </Button>
                        <Button color='green'
                            id='addbtn'
                            type="button"
                            className="button-submit"
                            onClick={() => this.addNote()}
                            disabled={!this}> Reject {this.props.practiceLabelName}</Button>
                    </Modal.Actions>
                </Form>
            </Modal>
        )
    }
}

export default PracticeRejectionNotesModal